module.exports = "<app-tour-map [side]=\"Side.Left\" [selector]=\"false\">\n</app-tour-map>\n"